<template>
  <ul :class="$style.optionList">
    <li v-for="(itemOption, index) in itemOptions" :key="itemOption.itemOptionSlug" :class="$style.optionItem">
      <p :class="$style.optionTitle">{{ itemOption.name }}<span v-if="itemOption.required" :class="$style.required">必須</span></p>
      <ISelect
        v-model="itemOptionVariantSlugs[index]"
        :name="itemOption.name"
        :items="formatSelectItems(itemOption)"
        size="small"
        :rules="itemOption.required ? 'required' : ''"
        :placeholder="itemOption.required ? '選択してください' : ''"
        :class="$style.optionSelect"
        @update:model-value="onSelectChange"
      />
    </li>
  </ul>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { getItemOptionsOfItem, type ItemOption } from '@/js/lib/api/v1/item';
import ISelect from '@/js/components/molecules/ISelect.vue';

const props = defineProps<{
  itemId: number;
}>();
const emit = defineEmits<{
  (e: 'update:modelValue', itemOptionVariantSlugs: (string | undefined)[]): void;
}>();
const cartButtonEl = document.querySelector('.cart-button') as HTMLDivElement;
const itemOptions = ref<ItemOption[]>([]);
const formatSelectItems = (itemOption: ItemOption) =>
  [
    itemOption.required ? [] : [{ value: '', label: '選択しない' }],
    ...itemOption.itemOptionVariants.map((variant) => [
      {
        value: variant.itemOptionVariantSlug,
        label: `${variant.name}${variant.price > 0 ? `（¥${variant.price.toLocaleString()}）` : ''}`,
      },
    ]),
  ].flat();
const itemOptionVariantSlugs = ref<(string | undefined)[]>([]);
const onSelectChange = () => {
  emit('update:modelValue', itemOptionVariantSlugs.value.filter(Boolean));
};
onMounted(async () => {
  const data = await getItemOptionsOfItem(props.itemId);
  itemOptions.value = data.itemOptions;
  itemOptionVariantSlugs.value = itemOptions.value.map((itemOption) => (itemOption.required ? undefined : ''));
  cartButtonEl.removeAttribute('style');
});
</script>

<style module lang="scss">
.optionList {
  padding-bottom: 6px;
}

.optionItem {
  margin-bottom: 16px;
}

.optionTitle {
  margin-bottom: 8px;

  .required {
    background-color: #d9d9d9;
    border-radius: 3px;
    font-size: 12px;
    margin-left: 8px;
    padding: 3px 5px;
  }
}

.optionSelect :global(.el-select__wrapper) {
  border-radius: 4px;
}
</style>
